/* ═══════════════════════════════════════════════════════════
   ARRA — Cotizador: módulo de precios (live + cálculo)
   ═══════════════════════════════════════════════════════════
   Estrategia anti-adblock:
   1) Intenta APIs públicas (no están en EasyList/uBlock por defecto).
   2) Cachea en localStorage por 24h — el siguiente visitante en el mismo
      día no necesita la red.
   3) Si la red falla, usa cache (aunque esté vencida) → aún funciona.
   4) Si no hay cache, usa fallback hardcoded del schema (siempre disponible).
   5) Opcional: el usuario puede meter una URL de proxy propia (worker
      Cloudflare) en `prices_proxy_url` para evitar 100% los bloqueadores.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ── Configuración fija ────────────────────────────────────────────────
  var CONFIG = {
    LABOR_MXN: 3950,                // Mano de obra fija (todas las monturas)
    SUPPLIER_MARKUP: 1.15,          // 15% margen del proveedor sobre el oro
    DIAMOND_UTILITY: 2.2,           // Multiplicador de utilidad sobre precio Excel
    DIAMOND_TAX: 1.085,             // 8.5% taxes
    SHIPPING_USD: 40,               // Envío del proveedor
    FX_BUFFER_MXN: 1.0,             // +1 MXN al tipo de cambio para protegernos
    KARAT_GRAMS: { '10k': 2.5, '14k': 3.5, '18k': 5.0 }, // gramos de oro PURO equivalentes
    SMALL_DIAMOND_2MM_MXN: 140,     // Halo / Pavé / Canal — c/u
    PIEDRA_LATERAL_2_MXN: 1710,     // Piedra Lateral — c/u (0.2 ct)
    COLOR_SURCHARGE_MXN: 450,       // Surcharge por Oro Blanco u Oro Rosa (rodio / aleación)
    IVA_ENABLED: true,              // Cobrar IVA en el presupuesto recomendado (toggle desde Shopify)
    IVA_PCT: 0.16,                  // 16% IVA México
    GRAMS_PER_TROY_OUNCE: 31.1034768,
    CACHE_TTL_MS: 24 * 60 * 60 * 1000,
    CACHE_KEY: 'arra_prices_v1'
  };

  // ── Reglas de cada montura ────────────────────────────────────────────
  // extraGrams = gramos de oro puro adicionales sobre la base del solitario
  // smallDiamonds = nº de diamantes 2 mm (140 MXN c/u)
  // lateralDiamonds = nº de diamantes laterales tipo "Piedra Lateral" (1710 c/u)
  // needsSecondary / needsTertiary: muestran selectores adicionales
  var MOUNTING = {
    'Solitario':      { extraGrams: 0,   smallDiamonds: 0,  lateralDiamonds: 0 },
    'Halo':           { extraGrams: 1.0, smallDiamonds: 20, lateralDiamonds: 0 },
    'Pave':           { extraGrams: 1.0, smallDiamonds: 18, lateralDiamonds: 0 },
    'Canal':          { extraGrams: 1.5, smallDiamonds: 18, lateralDiamonds: 0 },
    'Catedral':       { extraGrams: 1.0, smallDiamonds: 0,  lateralDiamonds: 0 },
    'Bisel':          { extraGrams: 3.0, smallDiamonds: 0,  lateralDiamonds: 0 },
    'Engastado':      { extraGrams: 2.0, smallDiamonds: 0,  lateralDiamonds: 0 },
    'Piedra Lateral': { extraGrams: 1.5, smallDiamonds: 0,  lateralDiamonds: 2 },
    '3 piedras':      { extraGrams: 1.8, smallDiamonds: 0,  lateralDiamonds: 0, needsSecondary: true, needsTertiary: true },
    '2 piedras':      { extraGrams: 1.5, smallDiamonds: 0,  lateralDiamonds: 0, needsSecondary: true }
  };

  // ── Matriz de precios de diamantes (Excel — USD por piedra) ──────────
  // Eje X: quilates en pasos de 0.1 desde 0.3 hasta 10.0 (98 valores).
  var DIAMOND_PRICES_USD = {
    "Redondo":[117,128,139,150,161,172,183,194,219,244,269,294,319,338,357,375,394,413,429,445,461,477,493,510,527,544,561,578,588,597,607,616,626,643,661,678,696,713,756,798,841,883,926,946,966,986,1006,1026,1058,1091,1123,1156,1188,1220,1253,1285,1318,1350,1370,1391,1411,1431,1452,1472,1492,1512,1533,1553,1573,1594,1614,1635,1655,1675,1696,1716,1737,1757,1834,1910,1987,2063,2140,2217,2293,2370,2446,2523,2600,2676,2753,2829,2906,2983,3059,3136,3212,3289],
    "Princesa":[137,153,169,185,201,217,233,249,263,277,291,305,319,339,359,379,399,419,441,464,486,509,531,546,560,575,589,604,636,669,701,734,766,789,812,834,857,880,902,924,947,969,991,991,992,992,993,993,1021,1050,1079,1107,1136,1164,1193,1221,1250,1278,1316,1354,1392,1430,1468,1505,1543,1581,1619,1657,1687,1717,1747,1777,1807,1837,1867,1897,1927,1957,2045,2134,2222,2311,2399,2488,2576,2665,2753,2842,2930,3018,3107,3195,3284,3372,3461,3549,3638,3726],
    "Radiante":[139,150,160,171,181,192,202,213,222,231,239,248,257,285,313,341,369,397,418,439,460,481,502,518,534,550,566,582,598,615,631,648,664,679,693,708,722,737,781,825,869,913,957,978,998,1019,1039,1060,1070,1080,1091,1101,1111,1121,1131,1142,1152,1162,1192,1221,1251,1280,1310,1339,1369,1398,1428,1457,1482,1506,1531,1556,1581,1605,1630,1655,1679,1704,1719,1735,1750,1765,1781,1796,1811,1826,1842,1857,1872,1888,1903,1918,1934,1949,1964,1979,1995,2010],
    "Asscher":[165,179,193,207,220,234,248,262,274,286,298,310,322,348,374,401,427,453,485,517,549,581,613,619,625,630,636,642,692,741,791,840,890,909,928,948,967,986,1009,1032,1054,1077,1100,1150,1200,1250,1300,1350,1396,1443,1490,1536,1583,1629,1676,1722,1769,1815,1844,1872,1901,1929,1958,1986,2015,2043,2072,2100,2125,2150,2175,2200,2225,2250,2275,2300,2325,2350,2367,2385,2402,2419,2436,2454,2471,2488,2505,2523,2540,2557,2574,2592,2609,2626,2643,2661,2678,2695],
    "Cushion":[155,167,179,191,203,215,227,239,251,263,276,288,300,320,340,360,380,400,427,455,482,510,537,546,556,565,575,584,624,665,705,746,786,787,789,790,792,793,851,909,968,1026,1084,1115,1146,1178,1209,1240,1255,1270,1285,1300,1316,1331,1346,1361,1376,1391,1419,1447,1476,1504,1532,1560,1588,1617,1645,1673,1707,1742,1776,1811,1845,1879,1914,1948,1983,2017,2044,2071,2097,2124,2151,2178,2205,2231,2258,2285,2312,2339,2365,2392,2419,2446,2473,2499,2526,2553],
    "Ovalado":[122,140,158,176,195,213,231,249,266,283,299,316,333,354,376,397,419,440,457,474,490,507,524,543,562,582,601,620,645,670,696,721,746,751,757,762,768,773,796,818,841,863,886,926,966,1005,1045,1085,1105,1125,1145,1165,1185,1204,1224,1244,1264,1284,1303,1322,1341,1360,1380,1399,1418,1437,1456,1475,1521,1566,1612,1657,1703,1749,1794,1840,1885,1931,1959,1988,2016,2044,2073,2101,2129,2157,2186,2214,2242,2271,2299,2327,2356,2384,2412,2440,2469,2497],
    "Esmeralda":[113,126,139,152,165,178,191,204,217,230,242,255,268,288,309,329,350,370,390,409,429,448,468,479,490,500,511,522,550,579,607,636,664,683,702,722,741,760,780,799,819,838,858,864,871,877,884,890,894,897,901,904,908,912,915,919,922,926,951,975,1000,1025,1050,1074,1099,1124,1148,1173,1197,1221,1246,1270,1294,1318,1342,1367,1391,1415,1442,1470,1497,1525,1552,1580,1607,1635,1662,1690,1717,1744,1772,1799,1827,1854,1882,1909,1937,1964],
    "Pera":[118,133,148,163,177,192,207,222,242,263,283,304,324,351,377,404,430,457,475,493,512,530,548,561,574,587,600,613,642,671,699,728,757,763,768,774,779,785,791,797,803,809,815,841,867,894,920,946,1005,1065,1124,1183,1243,1302,1361,1420,1480,1539,1546,1552,1559,1566,1573,1579,1586,1593,1599,1606,1663,1719,1776,1833,1890,1946,2003,2060,2116,2173,2191,2209,2227,2245,2263,2280,2298,2316,2334,2352,2370,2388,2406,2424,2442,2459,2477,2495,2513,2531],
    "Marquesa":[111,130,150,169,188,207,227,246,278,310,342,374,406,414,423,431,440,448,470,492,513,535,557,573,588,604,619,635,650,664,679,693,708,718,729,739,750,760,815,871,926,982,1037,1056,1074,1093,1111,1130,1139,1148,1157,1166,1175,1184,1193,1202,1211,1220,1229,1238,1246,1255,1264,1273,1282,1290,1299,1308,1320,1332,1344,1356,1368,1380,1392,1404,1416,1428,1472,1517,1561,1605,1650,1694,1738,1783,1827,1872,1916,1960,2005,2049,2093,2138,2182,2226,2271,2315],
    "Corazón":[135,158,181,204,226,249,272,295,305,315,326,336,346,371,396,420,445,470,497,524,550,577,604,612,620,628,636,644,700,755,811,866,922,942,961,981,1000,1020,1040,1060,1079,1099,1119,1185,1251,1318,1384,1450,1483,1516,1550,1583,1616,1649,1682,1716,1749,1782,1819,1857,1894,1931,1969,2006,2043,2080,2118,2155,2187,2219,2251,2283,2315,2347,2379,2411,2443,2475,2521,2567,2613,2659,2705,2751,2797,2843,2889,2935,2981,3027,3073,3119,3165,3211,3257,3303,3349,3395],
    "Rose Cut":[201,213,225,237,250,262,274,286,302,318,334,350,366,387,409,430,452,473,493,512,532,551,571,582,592,603,613,624,668,712,756,800,844,885,926,968,1009,1050,1100,1150,1200,1250,1300,1360,1420,1480,1540,1600,1640,1680,1720,1760,1800,1840,1880,1920,1960,2000,2050,2100,2150,2200,2250,2300,2350,2400,2450,2500,2560,2620,2680,2740,2800,2860,2920,2980,3040,3100,3155,3210,3265,3320,3375,3430,3485,3540,3595,3650,3705,3760,3815,3870,3925,3980,4035,4090,4145,4200],
    "Old European":[250,283,317,350,384,417,451,484,544,605,665,726,786,789,791,794,796,799,964,1130,1295,1461,1626,1681,1736,1790,1845,1900,2020,2140,2260,2380,2500,2835,3170,3504,3839,4174,4303,4431,4560,4688,4817,5212,5608,6003,6399,6794,6858,6923,6987,7051,7116,7180,7244,7308,7373,7437,7513,7590,7666,7742,7819,7895,7971,8047,8124,8200,8281,8363,8444,8525,8607,8688,8769,8850,8932,9013,9137,9262,9386,9510,9635,9759,9883,10008,10132,10257,10381,10505,10630,10754,10878,11003,11127,11251,11376,11500],
    "Media Luna":[137,177,216,256,296,336,375,415,470,524,579,633,688,722,756,791,825,859,968,1077,1186,1295,1404,1428,1452,1476,1500,1524,1628,1732,1835,1939,2043,2094,2146,2197,2249,2300,2380,2460,2540,2620,2700,2800,2900,3000,3100,3200,3280,3360,3440,3520,3600,3680,3760,3840,3920,4000,4090,4180,4270,4360,4450,4540,4630,4720,4810,4900,5000,5100,5200,5300,5400,5500,5600,5700,5800,5900,6005,6110,6215,6320,6425,6530,6635,6740,6845,6950,7055,7160,7265,7370,7475,7580,7685,7790,7895,8000],
    "Baguette Trapecio":[181,205,230,254,278,302,327,351,442,533,623,714,805,883,962,1040,1119,1197,1300,1403,1506,1609,1712,1750,1787,1825,1862,1900,1938,1976,2015,2053,2091,2138,2185,2232,2279,2326,2369,2412,2454,2497,2540,2583,2625,2668,2710,2753,2771,2788,2806,2824,2842,2859,2877,2895,2912,2930,3027,3124,3221,3318,3415,3512,3609,3706,3803,3900,4028,4155,4283,4411,4539,4666,4794,4922,5049,5177,5268,5359,5450,5542,5633,5724,5815,5906,5997,6089,6180,6271,6362,6453,6544,6635,6727,6818,6909,7000],
    "Baguette":[146,157,169,180,192,203,215,226,253,280,308,335,362,395,429,462,496,529,569,609,649,689,729,749,768,788,807,827,995,1163,1331,1499,1667,1714,1760,1807,1853,1900,1960,2020,2080,2140,2200,2280,2360,2440,2520,2600,2660,2720,2780,2840,2900,2960,3020,3080,3140,3200,3270,3340,3410,3480,3550,3620,3690,3760,3830,3900,3990,4080,4170,4260,4350,4440,4530,4620,4710,4800,4885,4970,5055,5140,5225,5310,5395,5480,5565,5650,5735,5820,5905,5990,6075,6160,6245,6330,6415,6500],
    "Hexágono":[146,176,206,236,266,296,326,356,391,426,461,496,531,600,669,739,808,877,988,1099,1209,1320,1431,1525,1619,1712,1806,1900,2043,2186,2329,2472,2615,2662,2709,2756,2803,2850,2905,2960,3014,3069,3124,3299,3474,3650,3825,4000,4122,4244,4366,4488,4610,4731,4853,4975,5097,5219,5361,5503,5644,5786,5928,6070,6212,6353,6495,6637,6768,6899,7030,7161,7292,7422,7553,7684,7815,7946,7982,8017,8053,8089,8125,8160,8196,8232,8267,8303,8339,8374,8410,8446,8482,8517,8553,8589,8624,8660],
    "Cometa":[182,207,233,258,283,308,334,359,428,497,566,635,704,785,867,948,1030,1111,1198,1284,1371,1457,1544,1634,1724,1813,1903,1993,2140,2286,2433,2579,2726,2998,3269,3541,3812,4084,4150,4217,4283,4350,4416,4496,4577,4657,4738,4818,4956,5094,5233,5371,5509,5647,5785,5924,6062,6200,6365,6530,6695,6860,7025,7190,7355,7520,7685,7850,8015,8180,8345,8510,8675,8840,9005,9170,9335,9500,9650,9800,9950,10100,10250,10400,10550,10700,10850,11000,11150,11300,11450,11600,11750,11900,12050,12200,12350,12500],
    "Old Mine":[200,229,258,287,315,344,373,402,453,505,556,608,659,689,719,749,779,809,861,913,964,1016,1068,1110,1152,1195,1237,1279,1344,1409,1474,1539,1604,1634,1664,1693,1723,1753,1852,1950,2049,2147,2246,2357,2468,2578,2689,2800,2867,2934,3001,3068,3136,3203,3270,3337,3404,3471,3600,3729,3858,3987,4116,4245,4374,4503,4632,4761,4859,4958,5056,5154,5253,5351,5449,5547,5646,5744,5832,5920,6007,6095,6183,6271,6359,6446,6534,6622,6710,6798,6885,6973,7061,7149,7237,7324,7412,7500],
    "Trapecio":[128,164,199,235,270,306,341,377,423,469,516,562,608,636,665,693,722,750,868,987,1105,1224,1342,1394,1447,1499,1552,1604,1663,1723,1782,1842,1901,1981,2061,2140,2220,2300,2400,2501,2601,2702,2802,2822,2841,2861,2880,2900,2911,2923,2934,2946,2957,2968,2980,2991,3003,3014,3070,3127,3183,3239,3296,3352,3408,3464,3521,3577,3665,3752,3840,3928,4016,4103,4191,4279,4366,4454,4514,4573,4633,4692,4752,4812,4871,4931,4990,5050,5110,5169,5229,5288,5348,5408,5467,5527,5586,5646],
    "Triangular":[140,166,192,218,243,269,295,321,369,416,464,511,559,621,683,744,806,868,949,1030,1111,1192,1273,1318,1363,1409,1454,1499,1711,1924,2136,2349,2561,2622,2683,2744,2805,2866,3270,3674,4078,4482,4886,5029,5172,5314,5457,5600,5704,5807,5911,6014,6118,6221,6325,6428,6532,6635,6722,6808,6895,6981,7068,7154,7241,7327,7414,7500,7630,7760,7890,8020,8150,8280,8410,8540,8670,8800,8935,9070,9205,9340,9475,9610,9745,9880,10015,10150,10285,10420,10555,10690,10825,10960,11095,11230,11365,11500]
  };

  // ── Interpolación lineal entre quilates ──────────────────────────────
  function diamondUSD(shape, carats) {
    var arr = DIAMOND_PRICES_USD[shape];
    if (!arr || !carats) return 0;
    // 0.3 → idx 0 ; 10.0 → idx 97 ; step 0.1
    var x = (carats - 0.3) * 10;
    if (x <= 0) return arr[0];
    if (x >= arr.length - 1) return arr[arr.length - 1];
    var i = Math.floor(x);
    var frac = x - i;
    return Math.round(arr[i] + frac * (arr[i + 1] - arr[i]));
  }

  // ── Cache localStorage 24h ───────────────────────────────────────────
  function readCache() {
    try {
      var raw = localStorage.getItem(CONFIG.CACHE_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || !c.t || !c.gold || !c.fx) return null;
      return c;
    } catch (_) { return null; }
  }
  function writeCache(gold, fx) {
    try {
      localStorage.setItem(CONFIG.CACHE_KEY, JSON.stringify({ t: Date.now(), gold: gold, fx: fx }));
    } catch (_) {}
  }
  function cacheFresh(c) { return c && (Date.now() - c.t) < CONFIG.CACHE_TTL_MS; }

  // ── Fetch helpers — múltiples endpoints, anti-adblock ────────────────
  function timeoutFetch(url, ms) {
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'omit', cache: 'no-store' })
      .then(function (r) { if (timer) clearTimeout(timer); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .catch(function (e) { if (timer) clearTimeout(timer); throw e; });
  }

  // Gold: USD per gram (oro puro 24k)
  function fetchGoldUSDPerGram(proxyUrl) {
    var attempts = [];
    if (proxyUrl) attempts.push(function () {
      return timeoutFetch(proxyUrl + (proxyUrl.indexOf('?') > -1 ? '&' : '?') + 'q=gold', 8000)
        .then(function (j) { return j.usd_per_gram || (j.price_oz / CONFIG.GRAMS_PER_TROY_OUNCE); });
    });
    // Free, no API key:
    attempts.push(function () {
      return timeoutFetch('https://api.gold-api.com/price/XAU', 8000)
        .then(function (j) { if (!j.price) throw new Error('no price'); return j.price / CONFIG.GRAMS_PER_TROY_OUNCE; });
    });
    // Backup endpoint:
    attempts.push(function () {
      return timeoutFetch('https://data-asg.goldprice.org/dbXRates/USD', 8000)
        .then(function (j) {
          var item = j.items && j.items[0];
          if (!item || !item.xauPrice) throw new Error('no xauPrice');
          return item.xauPrice / CONFIG.GRAMS_PER_TROY_OUNCE;
        });
    });
    return chain(attempts);
  }

  // FX: USD → MXN
  function fetchUSDtoMXN(proxyUrl) {
    var attempts = [];
    if (proxyUrl) attempts.push(function () {
      return timeoutFetch(proxyUrl + (proxyUrl.indexOf('?') > -1 ? '&' : '?') + 'q=fx', 8000)
        .then(function (j) { return j.mxn || (j.rates && j.rates.MXN); });
    });
    attempts.push(function () {
      return timeoutFetch('https://open.er-api.com/v6/latest/USD', 8000)
        .then(function (j) { if (!j.rates || !j.rates.MXN) throw new Error('no MXN'); return j.rates.MXN; });
    });
    attempts.push(function () {
      return timeoutFetch('https://api.exchangerate-api.com/v4/latest/USD', 8000)
        .then(function (j) { if (!j.rates || !j.rates.MXN) throw new Error('no MXN'); return j.rates.MXN; });
    });
    return chain(attempts);
  }

  function chain(arr) {
    return arr.reduce(function (p, fn) {
      return p.catch(function () { return fn(); });
    }, Promise.reject(new Error('init')));
  }

  // ── Proxy single-call (Worker /prices) — devuelve ambos en una sola request
  // Formato del Worker: { goldUSDperGram, usdToMxn, source, cachedAt }
  // Aceptamos también formatos alternos por compatibilidad.
  function fetchPricesFromProxy(proxyUrl) {
    return timeoutFetch(proxyUrl, 8000).then(function (j) {
      var gold = j.goldUSDperGram || j.usd_per_gram || (j.price_oz ? j.price_oz / CONFIG.GRAMS_PER_TROY_OUNCE : null);
      var fx   = j.usdToMxn || j.mxn || (j.rates && j.rates.MXN);
      if (!gold || !fx) throw new Error('proxy shape mismatch');
      return { gold: gold, fx: fx };
    });
  }

  // ── API pública ───────────────────────────────────────────────────────
  // getPrices(opts): { fallbackGoldUSDperG, fallbackUSDtoMXN, proxyUrl }
  // → Promise<{ goldUSDperGram, usdToMxn, fresh }>
  function getPrices(opts) {
    opts = opts || {};
    var cache = readCache();
    if (cacheFresh(cache)) {
      return Promise.resolve({ goldUSDperGram: cache.gold, usdToMxn: cache.fx, fresh: true, source: 'cache' });
    }

    // ── Camino 1: si hay proxy configurado, intentarlo primero (1 sola request, anti-adblock)
    var proxyAttempt = opts.proxyUrl
      ? fetchPricesFromProxy(opts.proxyUrl).catch(function () { return null; })
      : Promise.resolve(null);

    return proxyAttempt.then(function (proxyResult) {
      if (proxyResult && proxyResult.gold && proxyResult.fx) {
        writeCache(proxyResult.gold, proxyResult.fx);
        return { goldUSDperGram: proxyResult.gold, usdToMxn: proxyResult.fx, fresh: true, source: 'proxy' };
      }
      // ── Camino 2: APIs públicas (fallan si hay ad-blocker)
      return Promise.all([
        fetchGoldUSDPerGram(opts.proxyUrl).catch(function () { return null; }),
        fetchUSDtoMXN(opts.proxyUrl).catch(function () { return null; })
      ]).then(function (vals) {
        var gold = vals[0], fx = vals[1];
        if (gold && fx) {
          writeCache(gold, fx);
          return { goldUSDperGram: gold, usdToMxn: fx, fresh: true, source: 'api' };
        }
        // API falló — usar cache vencida
        if (cache) {
          return {
            goldUSDperGram: gold || cache.gold,
            usdToMxn: fx || cache.fx,
            fresh: false,
            source: 'stale-cache'
          };
        }
        // Sin cache — fallback duro
        return {
          goldUSDperGram: gold || opts.fallbackGoldUSDperG || 135,
          usdToMxn: fx || opts.fallbackUSDtoMXN || 20.5,
          fresh: false,
          source: 'fallback'
        };
      });
    });
  }

  // ── Cálculos ──────────────────────────────────────────────────────────
  // Precio MXN por gramo de oro PURO (con margen del proveedor + buffer FX)
  function goldMXNperG(prices) {
    var fx = (prices.usdToMxn || 18) + CONFIG.FX_BUFFER_MXN;
    return prices.goldUSDperGram * CONFIG.SUPPLIER_MARKUP * fx;
  }

  // Costo solo del oro BASE (gramos estándar, sin extra de montura)
  function metalBaseCostMXN(karat, prices) {
    var baseG = CONFIG.KARAT_GRAMS[karat] || 0;
    return goldMXNperG(prices) * baseG;
  }

  // Precio del anillo completo (base + extra montura) — mantener por compat
  function metalCostMXN(karat, mountingName, prices) {
    var m = MOUNTING[mountingName] || { extraGrams: 0 };
    return metalBaseCostMXN(karat, prices) + goldMXNperG(prices) * (m.extraGrams || 0);
  }

  // Precio MXN de un diamante (Excel × 2.2 × 1.085 + envío) en MXN
  function diamondCostMXN(shape, carats, prices) {
    if (!shape || !carats) return 0;
    var baseUSD = diamondUSD(shape, carats);
    if (!baseUSD) return 0;
    var totalUSD = baseUSD * CONFIG.DIAMOND_UTILITY * CONFIG.DIAMOND_TAX + CONFIG.SHIPPING_USD;
    var fx = (prices.usdToMxn || 18) + CONFIG.FX_BUFFER_MXN;
    return totalUSD * fx;
  }

  // Precio del botón "Preferencia de Metal" (solo el oro a ese karat,
  // sin mano de obra ni diamantes — para que el cliente vea de qué orden son)
  function metalButtonMXN(karat, prices) {
    var g = CONFIG.KARAT_GRAMS[karat] || 0;
    return goldMXNperG(prices) * g;
  }

  // Cotización completa
  // input: { karat, mounting, mainShape, mainCt,
  //          secondaryShape, secondaryCt, tertiaryShape, tertiaryCt }
  function calcQuote(input, prices) {
    var m = MOUNTING[input.mounting] || { extraGrams: 0, smallDiamonds: 0, lateralDiamonds: 0 };

    var metalBase = metalBaseCostMXN(input.karat, prices);
    var metalExtra = goldMXNperG(prices) * (m.extraGrams || 0);
    var metal = metalBase + metalExtra; // total metal para backwards compat
    var labor = CONFIG.LABOR_MXN;
    var smallDiamonds = (m.smallDiamonds || 0) * CONFIG.SMALL_DIAMOND_2MM_MXN;
    var lateralDiamonds = (m.lateralDiamonds || 0) * CONFIG.PIEDRA_LATERAL_2_MXN;
    // mountingTotal = lo que muestra la tarjeta de montura (extra oro + mano de obra + smalls/laterals)
    var mountingTotal = metalExtra + labor + smallDiamonds + lateralDiamonds;

    var mainDiamond = diamondCostMXN(input.mainShape, input.mainCt, prices);
    var secondaryDiamond = m.needsSecondary ? diamondCostMXN(input.secondaryShape, input.secondaryCt, prices) : 0;
    var tertiaryDiamond = m.needsTertiary ? diamondCostMXN(input.tertiaryShape, input.tertiaryCt, prices) : 0;

    // Surcharge por color: Oro Blanco u Oro Rosa requieren aleación/rodio adicional
    var colorSurcharge = (input.color === 'Oro Blanco' || input.color === 'Oro Rosa')
      ? CONFIG.COLOR_SURCHARGE_MXN : 0;

    var total = metalBase + mountingTotal + mainDiamond + secondaryDiamond + tertiaryDiamond + colorSurcharge;

    // IVA sobre el subtotal. `total` se mantiene como SUBTOTAL (sin IVA) para no
    // romper la lógica de diamante natural ("+ diamante a cotizar"); el IVA y el
    // gran total van aparte.
    var iva = CONFIG.IVA_ENABLED ? total * CONFIG.IVA_PCT : 0;
    var totalConIva = total + iva;

    return {
      total: total,
      iva: iva,
      ivaPct: CONFIG.IVA_PCT,
      ivaEnabled: !!CONFIG.IVA_ENABLED,
      totalConIva: totalConIva,
      breakdown: {
        metal: metalBase,       // solo oro base → "Oro 18k amarillo"
        mountingTotal: mountingTotal, // extra oro + mano de obra → coincide con tarjeta
        labor: labor,           // por si se usa en otro lugar
        smallDiamonds: smallDiamonds,
        lateralDiamonds: lateralDiamonds,
        mainDiamond: mainDiamond,
        secondaryDiamond: secondaryDiamond,
        tertiaryDiamond: tertiaryDiamond,
        colorSurcharge: colorSurcharge
      },
      mounting: m
    };
  }

  // Format MXN — pesos enteros con separador de miles
  function fmtMXN(n) {
    if (!isFinite(n) || n <= 0) return '—';
    return '$' + Math.round(n).toLocaleString('es-MX') + ' MXN';
  }

  // Aproximado: redondea a $500 más cercano y muestra "≈ $X,XXX MXN"
  function fmtMXNApprox(n) {
    if (!isFinite(n) || n <= 0) return '—';
    var r = Math.round(n / 500) * 500;
    return '≈ $' + r.toLocaleString('es-MX') + ' MXN';
  }

  // Lista de quilates disponibles para selectores secundarios/terciarios
  function caratsList() {
    var arr = [];
    for (var i = 3; i <= 100; i++) arr.push((i / 10).toFixed(1));
    return arr;
  }

  // ── Exportar al global ────────────────────────────────────────────────
  window.ArraCotizador = {
    CONFIG: CONFIG,
    MOUNTING: MOUNTING,
    DIAMOND_PRICES_USD: DIAMOND_PRICES_USD,
    diamondUSD: diamondUSD,
    diamondCostMXN: diamondCostMXN,
    metalCostMXN: metalCostMXN,
    metalButtonMXN: metalButtonMXN,
    goldMXNperG: goldMXNperG,
    calcQuote: calcQuote,
    getPrices: getPrices,
    fmtMXN: fmtMXN,
    fmtMXNApprox: fmtMXNApprox,
    caratsList: caratsList,
    shapesList: function () { return Object.keys(DIAMOND_PRICES_USD); }
  };
})();
